{
    "page_header": {
        "title": "",
        "subtitle": "",
        "image": null
    },
    "sections": [
        {
            "section_id": "contact_us_faq",
            "title": "Frequently Asked Questions (FAQ)",
            "subtitle": "",
            "image": null,
            "faqs": [
                {
                    "question": "How does it work for shoppers?",
                    "answer": "After completing your transaction, provide your unique ID or QR code to the cashier, who effortlessly scans it using our app. Then you will receive a real-time notification with your digital receipt securely stored in the app. By the end you can access your digital receipts anytime, explore exclusive deals, and enjoy a shopping experience tailored to your preferences."
                },
                {
                    "question": "How does it work for sellers?",
                    "answer": "Once you connect with us and choose the optimal deal for your business, we seamlessly integrate our solution into your Point of Sale (POS) system. As customers receive their digital receipt, you gain insightful data on purchasing patterns, empowering you to tailor marketing strategies, enhance customer engagement, and elevate your store performance."
                },
                {
                    "question": "What is wrong with paper receipts?",
                    "answer": "Not only that paper receipts are non recyclable, but also in order to make those receipts the world uses up to 25 millions of trees ,18 Billions liters of water and 22 million barrels of fuel oil."
                },
                {
                    "question": "Can I trust Receeto with my sensitive financial information?",
                    "answer": "Absolutely. Security is our top priority. Receeto employs advanced encryption protocols to safeguard your data, ensuring that your sensitive financial information is protected and remains confidential."
                }
            ]
        }
    ],
    "contact_info": {
        "email": "contact@receeto.com",
        "phone_number": "+216 94 519 633"
    }
}